// Provider component
import { createContext, ReactNode, useContext, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SessionStorageKeys } from 'enums';

const SubscriberIdContext = createContext<string | undefined>(undefined);

export const SubscriberIdProvider = ({ children }: { children: ReactNode }) => {
  const subscriberId = useMemo(() => {
    let storedSubscriberId = sessionStorage.getItem(SessionStorageKeys.WebsocketSubscriberId);
    if (!storedSubscriberId) {
      storedSubscriberId = uuidv4();
      sessionStorage.setItem(SessionStorageKeys.WebsocketSubscriberId, storedSubscriberId);
    }
    return storedSubscriberId;
  }, []);

  return <SubscriberIdContext.Provider value={subscriberId}>{children}</SubscriberIdContext.Provider>;
};

export const useSubscriberId = (): string => {
  const subscriberId = useContext(SubscriberIdContext);
  if (subscriberId === undefined) {
    throw new Error('useSubscriberId must be used within a SubscriberIdProvider');
  }
  return subscriberId;
};
